// extracted by mini-css-extract-plugin
export default {"container":"infoSection_container__oNUJe"};